import Tooltip from "@/components/atoms/Tooltip/Tooltip";
import { isMobile } from "react-device-detect";

import { metaRatingLogoLabel, simpleInfoIcon } from "../../../../icons";

export const MetaRatingTooltip = () => (
  <Tooltip
    content={
      <div className="flex flex-col text-sm text-white gap-y-2 w-64">
        <div className="w-36">{metaRatingLogoLabel}</div>
        <p>
          The Meta Rating gives you an indication of how well your team performs
          in-game. <br />
          <br />
          Each player's Meta Rating is calculated by our AI based on in-game
          attributes, weak foot, skill moves, height, body type and PlayStyles.
        </p>
      </div>
    }
    side={isMobile ? "bottom" : "right"}
    delayDuration={100}
  >
    <div className="w-4 h-4 text-white">{simpleInfoIcon}</div>
  </Tooltip>
);
